'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _ConfigSelectors = require('pricing-pages-unified-ui/selectors/ConfigSelectors');

var _Loadable = require('UIComponents/decorators/Loadable');

var _Loadable2 = _interopRequireDefault(_Loadable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Code splits between an authed component and a public component
// Takes in a loader so we can do the code splitting inside this function
var CodeSplitEnvWrapper = function (_React$Component) {
  _inherits(CodeSplitEnvWrapper, _React$Component);

  function CodeSplitEnvWrapper(props) {
    _classCallCheck(this, CodeSplitEnvWrapper);

    var _this = _possibleConstructorReturn(this, (CodeSplitEnvWrapper.__proto__ || Object.getPrototypeOf(CodeSplitEnvWrapper)).call(this, props));

    _this.authedComponent = null;
    _this.publicComponent = null;
    if (props.authedComponentLoader) {
      _this.authedComponent = (0, _Loadable2.default)({
        loader: props.authedComponentLoader,
        LoadingComponent: function LoadingComponent() {
          return null;
        },
        ErrorComponent: function ErrorComponent() {
          throw new Error('EnvironmentWrapper authed component Loadable error');
        }
      });
    }
    if (props.publicComponentLoader) {
      _this.publicComponent = (0, _Loadable2.default)({
        loader: props.publicComponentLoader,
        LoadingComponent: function LoadingComponent() {
          return null;
        },
        ErrorComponent: function ErrorComponent() {
          throw new Error('EnvironmentWrapper public component Loadable error');
        }
      });
    }
    return _this;
  }

  _createClass(CodeSplitEnvWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isAppAuth = _props.isAppAuth,
          authedComponentProps = _props.authedComponentProps,
          publicComponentProps = _props.publicComponentProps;


      if (isAppAuth && this.authedComponent) {
        return _react2.default.createElement(this.authedComponent, authedComponentProps);
      } else if (!isAppAuth && this.publicComponent) {
        return _react2.default.createElement(this.publicComponent, publicComponentProps);
      }

      return null;
    }
  }]);

  return CodeSplitEnvWrapper;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isAppAuth: (0, _ConfigSelectors.isAppAuthSelector)(state)
  };
};

CodeSplitEnvWrapper.propTypes = {
  // https://product.hubteam.com/docs/crm-handbook/practices/code-splitting.html#creating-a-chunk-with-dynamic-import
  // () => import(/* webpackChunkName: "authed-chunk" */  'path/to/component')
  authedComponentLoader: _react2.default.PropTypes.func,
  // () => import(/* webpackChunkName: "public-chunk" */  'path/to/component')
  publicComponentLoader: _react2.default.PropTypes.func,
  authedComponentProps: _react2.default.PropTypes.object.isRequired,
  publicComponentProps: _react2.default.PropTypes.object.isRequired,
  isAppAuth: _react2.default.PropTypes.bool.isRequired
};

CodeSplitEnvWrapper.defaultProps = {
  authedComponentLoader: null,
  publicComponentLoader: null,
  authedComponentProps: {},
  publicComponentProps: {}
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(CodeSplitEnvWrapper);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/CodeSplitEnvWrapper.js
// module id = 66
// module chunks = 3 4